import React from "react";

interface ButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  fullWidth?: boolean;
  variant?: "contained" | "outlined" | "gradient";
  className?: string;
  children?: React.ReactNode;
}

export default function Button({
  disabled,
  onClick,
  fullWidth,
  children,
  className,
  variant,
}: ButtonProps) {
  switch (variant) {
    case "contained":
      return (
        <button
          disabled={disabled}
          onClick={onClick}
          className={`${className} ${
            disabled ? "bg-gray-400" : "bg-[#6A67F2]"
          }  rounded-xl px-4 py-2 text-lg font-semibold text-white ${
            fullWidth && "w-full"
          }`}
        >
          {children}
        </button>
      );
    case "gradient":
      return (
        <div
          className={`${className} bg-gradient-to-r from-[#A73EE7] to-[#003BFF] rounded-3xl p-[2px] ${
            fullWidth && "w-full"
          }`}
        >
          <button
            disabled={disabled}
            onClick={onClick}
            className={`${
              disabled ? "bg-slate-300" : "bg-primary-100"
            }  rounded-3xl px-4 py-2 text-sm font-semibold text-white w-full`}
          >
            {children}
          </button>
        </div>
      );
    default:
      return (
        <button
          disabled={disabled}
          onClick={onClick}
          className={`${className} ${
            disabled ? "bg-gray-400" : "bg-[#6A67F2]"
          }  rounded-xl px-4 py-2 text-lg font-semibold text-white max-sm:px-2 max-sm:text-sm ${
            fullWidth && "w-full"
          }`}
        >
          {children}
        </button>
      );
  }
}
